import { createClient } from '@supabase/supabase-js';

// Use environment variables or safe fallbacks to prevent crashes
// These fallbacks allow the UI to render even if Supabase isn't connected yet
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);